export const sentryIgnoreErrors = [
  // handled by ysc-chunk-reload
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Failed to fetch dynamically imported module',
]
